class BaseMultishipValidator {
  validateItem(itemProperties) {
    this._loadData(itemProperties);
    return (
      this.isAddressComplete() &&
      this.isShippingComplete() &&
      this.isGiftMessageComplete()
    );
  }

  isShippingComplete() {
    this._loadShippingData();
    return !!this.shippingData.shippingMethod;
  }

  isShippingDateValid(date) {
    return true;
  }

  isAddressComplete() {
    this._loadAddressData();
    return !!(
      this.addressData &&
      this.addressData.firstName &&
      this.addressData.lastName &&
      this.addressData.address1 &&
      this.addressData.city &&
      this.addressData.provinceCode &&
      this.addressData.zip &&
      this.addressData.countryCode
    );
  }

  isGiftMessageComplete() {
    this._loadGiftMessageData();
    return !!(this.giftMessageData && this.giftMessageData.includeGiftMessage);
  }

  _loadData(itemProperties) {
    const propertiesString = itemProperties;

    if (propertiesString) {
      try {
        const unescapedString = this.unescapeHtml(propertiesString);
        this.properties = JSON.parse(unescapedString);

        const dataProperty = this.properties.find(
          (prop) => prop[0] === "_data",
        );
        this.data = this.normalizeDataProperty(
          dataProperty ? dataProperty[1] : {},
        );
      } catch (error) {
        this.data = {};
      }
    } else {
      this.data = {};
    }
  }

  normalizeDataProperty(dataPropertyValue) {
    if (!dataPropertyValue) return {};

    if (
      typeof dataPropertyValue === "object" &&
      !Array.isArray(dataPropertyValue)
    ) {
      return dataPropertyValue;
    }

    if (typeof dataPropertyValue !== "string") return {};

    const decodedString = this.unescapeHtml(dataPropertyValue);

    if (
      window.CartDataEncoder &&
      typeof window.CartDataEncoder.decode === "function"
    ) {
      const decoded = window.CartDataEncoder.decode(decodedString);
      if (decoded && typeof decoded === "object" && !Array.isArray(decoded)) {
        return decoded;
      }
    }

    try {
      const parsed = JSON.parse(decodedString);
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        return parsed;
      }
    } catch (e) {
      // fall through
    }

    return this.parseRubyHashFallback(decodedString);
  }

  parseRubyHashFallback(value) {
    if (!value || typeof value !== "string" || !value.includes("=>")) return {};

    const parsed = {};
    const pattern = /"([^"\\]+)"\s*=>\s*"((?:\\.|[^"\\])*)"/g;
    let match;

    while ((match = pattern.exec(value)) !== null) {
      parsed[match[1]] = match[2].replace(/\\"/g, '"');
    }

    return parsed;
  }

  _loadAddressData() {
    this.addressData = {
      firstName: this.data.firstName || "",
      lastName: this.data.lastName || "",
      address1: this.data.address1 || "",
      city: this.data.city || "",
      provinceCode: this.data.provinceCode || "",
      zip: this.data.zip || "",
      countryCode: this.data.countryCode || "",
    };
  }

  _loadShippingData() {
    this.shippingData = {
      shippingMethod: this.data.shippingMethod || "",
      shippingPrice: this.data.shippingPrice || "",
      requestedShipDate: this.data.requestedShipDate || "",
    };
  }

  _loadGiftMessageData() {
    this.giftMessageData = {
      message: this.data.giftMessage || "",
      includeGiftMessage: this.data.includeGiftMessage || "",
    };
  }

  unescapeHtml(str) {
    const htmlEntities = {
      "&nbsp;": " ",
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'",
    };
    return str.replace(/&[^;]+;/g, (entity) => htmlEntities[entity] || entity);
  }
}
